function describeIncomingCap({ inventoryQuantity, incomingStockRaw, cartQtyForVariant = 0, inventoryPolicy, available = true }) {
  const incomingStock = typeof incomingStockRaw === "string" ? parseIncomingStockAttribute(incomingStockRaw) : incomingStockRaw;
  const incomingTotal = parseIncomingStockEntries(incomingStock);
  const inv = Number(inventoryQuantity);
  const cartQty = Number(cartQtyForVariant) || 0;
  const result = computeIncomingPreorderCanAdd({
    inventoryQuantity,
    incomingStockRaw,
    cartQtyForVariant: cartQty,
    inventoryPolicy,
    available
  });
  let baseRemaining = null;
  let skipReason = null;

  if (available === false) {
    skipReason = "variant not available";
  } else if (inventoryPolicy !== "deny" && inventoryPolicy !== "continue") {
    skipReason = `unsupported policy: ${inventoryPolicy}`;
  } else if (inventoryPolicy === "deny") {
    baseRemaining = Math.max(0, Number.isFinite(inv) ? inv : 0);
  } else if (inventoryPolicy === "continue") {
    baseRemaining = Math.max(0, incomingTotal + (Number.isFinite(inv) ? inv : 0));
  }

  const maxAllowed = result.capActive && baseRemaining != null ? baseRemaining : null;

  return {
    inventoryQuantity: inv,
    inventoryPolicy,
    incomingStock,
    incomingTotal,
    cartQty,
    available,
    baseRemaining,
    maxAllowed,
    excess: maxAllowed != null ? Math.max(0, cartQty - maxAllowed) : null,
    skipReason: result.capActive ? null : skipReason,
    ...result
  };
}
function parseIncomingStockEntries(raw) {
  if (raw == null || raw === "") {
    return 0;
  }
  let entries = raw;
  if (typeof raw === "string") {
    try {
      entries = JSON.parse(raw);
    } catch {
      return 0;
    }
  }
  if (!Array.isArray(entries)) {
    return 0;
  }
  return entries.reduce((sum, entry) => {
    const parts = String(entry).split(" - ");
    const qty = parseInt(parts[parts.length - 1]?.trim(), 10);
    return sum + (Number.isFinite(qty) ? qty : 0);
  }, 0);
}
function parseIncomingStockAttribute(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = raw;
    try {
      return JSON.parse(textarea.value);
    } catch {
      return null;
    }
  }
}
function getCartQtyForVariant(cart, variantId) {
  return (cart?.items || []).filter((item) => String(item.variant_id) === String(variantId)).reduce((sum, item) => sum + item.quantity, 0);
}
function computeIncomingPreorderCanAdd({ inventoryQuantity, incomingStockRaw, cartQtyForVariant = 0, inventoryPolicy, available = true }) {
  const incomingStock = typeof incomingStockRaw === "string" ? parseIncomingStockAttribute(incomingStockRaw) : incomingStockRaw;
  const incomingTotal = parseIncomingStockEntries(incomingStock);
  const inv = Number(inventoryQuantity);
  const cartQty = Number(cartQtyForVariant) || 0;

  if (available === false) {
    return { capActive: false, isPreorderIncoming: false, canAddNow: null };
  }

  if (inventoryPolicy === "deny") {
    const baseRemaining = Math.max(0, Number.isFinite(inv) ? inv : 0);
    return {
      capActive: true,
      isPreorderIncoming: false,
      canAddNow: Math.max(0, baseRemaining - cartQty)
    };
  }

  if (inventoryPolicy === "continue") {
    const baseRemaining = Math.max(0, incomingTotal + (Number.isFinite(inv) ? inv : 0));
    return {
      capActive: true,
      isPreorderIncoming: Number.isFinite(inv) && inv < 1 && incomingTotal > 0,
      canAddNow: Math.max(0, baseRemaining - cartQty)
    };
  }

  return { capActive: false, isPreorderIncoming: false, canAddNow: null };
}
function getOnHandRemaining(inventoryQuantity, cartQty) {
  const inv = Number(inventoryQuantity);
  if (!Number.isFinite(inv)) {
    return 0;
  }
  return Math.max(0, inv - (Number(cartQty) || 0));
}
function getSelectedQuantity(productForm) {
  const input = productForm.querySelector('.quantity-selector__input[name="quantity"]');
  const qty = input ? parseInt(input.value, 10) : 1;
  return Number.isFinite(qty) && qty > 0 ? qty : 1;
}
function getSoldOutLabel() {
  return window.themeVariables?.strings?.soldOutButton || "Sold out";
}
function getAddToCartLabel() {
  return window.themeVariables?.strings?.addToCartButton || "Add to cart";
}
function getPreOrderLabel() {
  return window.themeVariables?.strings?.preOrderButton || "Pre-order";
}
function resolveIncomingCapButtonLabel({ selectedQty, canAddNow, onHandRemaining }) {
  if (canAddNow <= 0) {
    return getSoldOutLabel();
  }
  if (selectedQty <= onHandRemaining) {
    return getAddToCartLabel();
  }
  return getPreOrderLabel();
}
function setSubmitButtonLabel(submitBtn, label) {
  if (!submitBtn) {
    return;
  }
  const buttonContent = submitBtn.querySelector("button-content");
  if (buttonContent) {
    buttonContent.textContent = label;
    if (buttonContent.hasAttribute("rotated-text")) {
      buttonContent.setAttribute("rotated-text", label);
    }
    if (buttonContent.hasAttribute("up-text")) {
      buttonContent.setAttribute("up-text", label);
    }
  } else {
    submitBtn.textContent = label;
  }
}
function updateIncomingCapButtonLabel(productForm) {
  if (productForm?.getAttribute("data-preorder-incoming") !== "true") {
    return;
  }
  const canAddNow = parseInt(productForm.getAttribute("data-preorder-can-add"), 10);
  if (!Number.isFinite(canAddNow)) {
    return;
  }
  const inv = parseInt(productForm.getAttribute("data-variant-inventory-quantity"), 10);
  const cartQty = parseInt(productForm.getAttribute("data-cart-qty"), 10) || 0;
  const onHandRemaining = getOnHandRemaining(inv, cartQty);
  const selectedQty = getSelectedQuantity(productForm);
  const submitBtn = productForm.querySelector('button[type="submit"]');
  if (!submitBtn) {
    return;
  }
  const soldOut = canAddNow <= 0;
  submitBtn.disabled = soldOut;
  setSubmitButtonLabel(submitBtn, resolveIncomingCapButtonLabel({ selectedQty, canAddNow, onHandRemaining }));
}
function normalizePreorderQuantityInput(productForm) {
  if (productForm?.getAttribute("data-preorder-incoming") !== "true") {
    return { clamped: false };
  }
  const max = parseInt(productForm.getAttribute("data-preorder-can-add"), 10);
  if (!Number.isFinite(max)) {
    return { clamped: false };
  }
  const input = productForm.querySelector('.quantity-selector__input[name="quantity"]');
  const qtySelector = productForm.querySelector("quantity-selector");
  if (!input) {
    return { clamped: false };
  }

  input.setCustomValidity("");

  const minQty = parseInt(input.min, 10) || 1;
  const qty = parseInt(input.value, 10);

  if (!Number.isFinite(qty) || qty <= max) {
    return { clamped: false };
  }

  const clampedQty = Math.max(minQty, max);

  if (qtySelector?.quantity != null) {
    qtySelector.quantity = String(clampedQty);
  } else {
    input.value = String(clampedQty);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  updateIncomingCapButtonLabel(productForm);

  return { clamped: true };
}
function validatePreorderQuantity(productForm) {
  normalizePreorderQuantityInput(productForm);
  return true;
}
async function fetchThemeCart(cartFromEvent) {
  if (cartFromEvent) {
    return cartFromEvent;
  }
  const response = await fetch(`${Shopify.routes.root}cart.js`);
  if (!response.ok) {
    throw new Error("cart fetch failed");
  }
  return response.json();
}
function applyIncomingCapUI(productForm, canAddNow, cartQty) {
  const soldOut = canAddNow <= 0;
  productForm.setAttribute("data-preorder-can-add", String(canAddNow));
  productForm.setAttribute("data-cart-qty", String(cartQty));
  productForm.toggleAttribute("data-cap-sold-out", soldOut);

  const qtySelector = productForm.querySelector("quantity-selector");
  if (qtySelector) {
    if (soldOut) {
      qtySelector.setAttribute("hidden", "");
    } else {
      qtySelector.removeAttribute("hidden");
    }
    const input = qtySelector.querySelector(".quantity-selector__input");
    if (input) {
      const minQty = parseInt(input.min, 10) || 1;

      if (soldOut) {
        input.removeAttribute("max");
      } else {
        input.max = String(canAddNow);
        input.defaultValue = String(minQty);
        const current = parseInt(input.value, 10);
        let nextQty = minQty;

        if (Number.isFinite(current) && current >= minQty && current <= canAddNow) {
          nextQty = current;
        } else if (Number.isFinite(current) && current > canAddNow) {
          nextQty = canAddNow;
        }

        qtySelector.quantity = String(nextQty);
      }
    }
  }

  updateIncomingCapButtonLabel(productForm);
}
async function refreshProductFormPreorderState(productForm, cartFromEvent) {
  if (!productForm || productForm.getAttribute("data-preorder-incoming") !== "true") {
    return;
  }
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) {
    return;
  }
  const inv = parseInt(productForm.getAttribute("data-variant-inventory-quantity"), 10);
  const policy = productForm.getAttribute("data-variant-inventory-policy");
  const incomingRaw = productForm.getAttribute("data-incoming-stock");
  let cart;
  try {
    cart = await fetchThemeCart(cartFromEvent);
  } catch {
    return;
  }
  const cartQty = getCartQtyForVariant(cart, variantInput.value);
  const { canAddNow } = computeIncomingPreorderCanAdd({
    inventoryQuantity: inv,
    incomingStockRaw: incomingRaw,
    cartQtyForVariant: cartQty,
    inventoryPolicy: policy,
    available: true
  });
  if (canAddNow == null) {
    return;
  }
  applyIncomingCapUI(productForm, canAddNow, cartQty);
}
function refreshAllProductFormPreorderStates(cartFromEvent) {
  document.querySelectorAll('product-form[data-preorder-incoming="true"]').forEach((form) => {
    refreshProductFormPreorderState(form, cartFromEvent);
  });
}
function onProductFormQuantityInput(event) {
  const input = event.target;
  if (!input.matches('.quantity-selector__input[name="quantity"]')) {
    return;
  }
  const productForm = input.closest("product-form");
  if (!productForm) {
    return;
  }
  normalizePreorderQuantityInput(productForm);
  updateIncomingCapButtonLabel(productForm);
}
let cartIncomingSyncInProgress = false;
let cartIncomingSyncLastRun = 0;
const CART_INCOMING_SYNC_DEBOUNCE_MS = 2500;

async function fetchCartIncomingSyncMeta() {
  const response = await fetch(`${Shopify.routes.root}?sections=cart-incoming-sync`);
  if (!response.ok) {
    throw new Error("cart incoming sync section fetch failed");
  }
  const sections = await response.json();
  const html = sections["cart-incoming-sync"];
  if (!html) {
    return [];
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  const dataNode = doc.getElementById("cart-incoming-sync-data");
  if (!dataNode?.textContent) {
    return [];
  }
  return JSON.parse(dataNode.textContent);
}

function planCartIncomingSyncAdjustments(cart, metaLines) {
  const metaByKey = new Map(metaLines.map((line) => [line.key, line]));
  const adjustments = [];
  const itemsByVariant = {};

  for (const item of cart.items || []) {
    (itemsByVariant[item.variant_id] ??= []).push(item);
  }

  for (const items of Object.values(itemsByVariant)) {
    const meta = metaByKey.get(items[0].key);
    if (!meta) {
      continue;
    }

    const cartQty = items.reduce((sum, line) => sum + line.quantity, 0);
    const cap = describeIncomingCap({
      inventoryQuantity: meta.inventory_quantity,
      incomingStockRaw: meta.incoming_stock,
      cartQtyForVariant: cartQty,
      inventoryPolicy: meta.inventory_policy,
      available: meta.available !== false
    });

    const { capActive, maxAllowed, excess } = cap;

    if (!capActive) {
      continue;
    }

    if (maxAllowed <= 0) {
      for (const item of items) {
        if (item.quantity > 0) {
          adjustments.push({
            key: item.key,
            quantity: 0,
            title: meta.title || item.title
          });
        }
      }
      continue;
    }

    let excessRemaining = excess;
    if (!excessRemaining || excessRemaining <= 0) {
      continue;
    }

    for (let index = items.length - 1; index >= 0 && excessRemaining > 0; index -= 1) {
      const item = items[index];
      const removeQty = Math.min(item.quantity, excessRemaining);
      const nextQty = item.quantity - removeQty;

      if (nextQty !== item.quantity) {
        adjustments.push({
          key: item.key,
          quantity: nextQty,
          title: meta.title || item.title
        });
      }

      excessRemaining -= removeQty;
    }
  }

  return adjustments;
}

async function syncCartWithIncomingStock(options = {}) {
  if (cartIncomingSyncInProgress) {
    return;
  }

  const now = Date.now();
  if (!options.force && now - cartIncomingSyncLastRun < CART_INCOMING_SYNC_DEBOUNCE_MS) {
    return;
  }

  cartIncomingSyncInProgress = true;

  try {
    const [cart, metaLines] = await Promise.all([fetchThemeCart(), fetchCartIncomingSyncMeta()]);

    if (!cart?.items?.length || !metaLines.length) {
      return;
    }

    const adjustments = planCartIncomingSyncAdjustments(cart, metaLines);
    if (!adjustments.length) {
      cartIncomingSyncLastRun = now;
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    const sectionsToBundle = /* @__PURE__ */ new Set();
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    let updatedCart = cart;

    for (const adjustment of adjustments) {
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: adjustment.key,
          quantity: adjustment.quantity,
          sections: [...sectionsToBundle].join(","),
          sections_url: window.location.pathname
        })
      });

      if (response.ok) {
        updatedCart = await response.json();
      }
    }

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    cartIncomingSyncLastRun = Date.now();

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "incoming-cart-sync",
        cart: updatedCart
      }
    }));

    if (window.themeVariables?.settings?.pageType === "cart") {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  } catch {
    // Silent fail — cart remains usable
  } finally {
    cartIncomingSyncInProgress = false;
  }
}

function setupCartIncomingSync() {
  const cartDrawer = document.querySelector("cart-drawer");

  cartDrawer?.addEventListener("dialog:after-show", () => {
    syncCartWithIncomingStock();
  });

  if (window.themeVariables?.settings?.pageType === "cart") {
    syncCartWithIncomingStock();
  }
}

function setupIncomingPreorderListeners() {
  const onCartUpdate = (event) => {
    if (event.detail?.baseEvent === "incoming-cart-sync") {
      return;
    }
    refreshAllProductFormPreorderStates(event.detail?.cart);
  };

  refreshAllProductFormPreorderStates();
  setupCartIncomingSync();
  document.documentElement.addEventListener("cart:change", onCartUpdate);
  document.addEventListener("cart:change", onCartUpdate);
  document.addEventListener("cart:refresh", () => {
    refreshAllProductFormPreorderStates();
  });
  document.addEventListener("product:rerender", () => {
    requestAnimationFrame(refreshAllProductFormPreorderStates);
  });
  document.addEventListener("variant:add", (event) => {
    if (event.detail?.cart) {
      refreshAllProductFormPreorderStates(event.detail.cart);
    }
  });
  window.addEventListener("pageshow", () => {
    refreshAllProductFormPreorderStates();
  });
  document.addEventListener("input", onProductFormQuantityInput);
  document.addEventListener("change", onProductFormQuantityInput);
}
window.validatePreorderQuantity = validatePreorderQuantity;
window.normalizePreorderQuantityInput = normalizePreorderQuantityInput;
window.refreshProductFormPreorderState = refreshProductFormPreorderState;
window.updateIncomingCapButtonLabel = updateIncomingCapButtonLabel;
window.syncCartWithIncomingStock = syncCartWithIncomingStock;
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupIncomingPreorderListeners);
} else {
  setupIncomingPreorderListeners();
}
